import { API_AUTH_ONBOARDING_COMPLETE } from '@/shared/constants/bff-endpoints';
import type { CompleteOnboardingPayload, CompleteOnboardingResponse } from '../model/complete-onboarding-payload';


export async function completeOnboarding (
    payload: CompleteOnboardingPayload,
): Promise<CompleteOnboardingResponse> {
    const response = await fetch(API_AUTH_ONBOARDING_COMPLETE, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify(payload),
    });

    return await response.json() as CompleteOnboardingResponse;
}
